import { ApplicantType, CompanyApplicantRelatedPartyType, TrustApplicantRelatedPartyType } from '@lendi/core-constants';

import { FIELD_VALUES } from '@funnels/constants';
import { RelatedParty, StoreApplicant } from '@funnels/types';

export enum GuarantorType {
  SecurityGuarantor = 'SECURITY_GUARANTOR',
  ServicingGuarantor = 'SERVICING_GUARANTOR',
}

export const getGuarantorType = (applicant: StoreApplicant, relatedParties: RelatedParty[]) => {
  if (applicant.applicantType !== ApplicantType.Guarantor || applicant.entity !== FIELD_VALUES.PERSON) {
    return null;
  }
  const isPersonTrusteeOrDirector = relatedParties.find(
    (item) =>
      (item.type === CompanyApplicantRelatedPartyType.Director ||
        item.type === TrustApplicantRelatedPartyType.Trustee) &&
      item.applicantId === applicant.id
  );
  if (isPersonTrusteeOrDirector) {
    return GuarantorType.ServicingGuarantor;
  } else {
    return GuarantorType.SecurityGuarantor;
  }
};
